<div class="accordion-item">
  <button type="button" class="accordion-item__header d-flex align-items-center justify-content-between w-100" (click)="toggle()">
    <span class="accordion-item__title fs-5 mb-0">{{ title }}</span>
    <svg
      class="accordion-item__chevron"
      [class.accordion-item__chevron--open]="isOpen"
      width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="accordion-item__body" *ngIf="isOpen" [innerHTML]="safeBodyHtml"></div>
</div>
